var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.inputContainerClass},[_c('v-switch',{staticClass:"mt-0",attrs:{"label":_vm.labelSwitch,"true-value":1,"false-value":0},on:{"change":_vm.handleInput},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }